import { IconWrapper } from '../runtime';
export default IconWrapper('pen', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M9 2.99976L10.4393 1.56042C11.0251 0.97463 11.9749 0.974628 12.5607 1.56041L14.4344 3.43414C15.0221 4.02186 15.0199 4.97542 14.4294 5.56039L12.9766 6.99976M9 2.99976L2.82114 9.17861C2.61174 9.38801 2.46901 9.65471 2.41093 9.9451L1.58825 14.0585C1.54627 14.2684 1.73134 14.4535 1.94126 14.4115L6.05321 13.5891C6.3445 13.5309 6.61193 13.3874 6.82161 13.177L12.9766 6.99976M9 2.99976L12.9766 6.99976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});